import { batch } from 'react-redux';
import { PayloadAction, Update } from '@reduxjs/toolkit';
import { selectVariableById } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpDispatch, GiftPdpState, GiftPdpThunk } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { computeHeightAndFontSize } from '@gift-variable-plugins/text-shared/textToFfCanvas';
import { selectComputedFontSizeById, selectComputedHeightById, selectInputById, updateComputedFontSizeByIds, updateComputedHeightByIds } from './_redux';

export const withFontMetricsUpdate = <T>(
    updater: (variableIds: string[], value: T) => PayloadAction<readonly Update<GiftJson.Input<any>>[], string>
) => {
    return (variableIds: string[], value: T): GiftPdpThunk => {
        return (dispatch, getState) => {
            batch(() => {
                dispatch(updater(variableIds, value));
                updateFontMetrics(dispatch, variableIds, getState());
            });
        };
    };
};

export const updateFontMetrics = (
    dispatch: GiftPdpDispatch,
    variableIds: string[],
    state: GiftPdpState
) => {

    for (const id of variableIds) {

        const input = selectInputById(state, id)!;
        const variable = selectVariableById(state, id)!;

        const { height: newHeight, fontSize: newFontSize }
            = computeHeightAndFontSize(input, variable);

        const oldHeight = selectComputedHeightById(state, id);
        const oldFontSize = selectComputedFontSizeById(state, id);

        if (newHeight !== oldHeight) {
            dispatch(updateComputedHeightByIds([id] as string[], newHeight));
        }

        if (newFontSize !== oldFontSize) {
            dispatch(updateComputedFontSizeByIds([id] as string[], newFontSize));
        }
    }
};